export const BEGIN_REQUEST = 'BEGIN_REQUEST';
export const FINISH_REQUEST = 'FINISH_REQUEST';
export const REQUEST_ERROR = 'REQUEST_ERROR';

export const DISPLAY_ALERT = 'DISPLAY_ALERT';
export const CLEAR_ALERT = 'CLEAR_ALERT';

export const GET_PUBLIC_POSTS_SUCCESS = 'GET_PUBLIC_POSTS_SUCCESS';
export const GET_SINGLE_PUBLIC_POST_SUCCESS = 'GET_SINGLE_PUBLIC_POST_SUCCESS';
